/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { ImageCover } from "cms/images/image-cover";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { ImageInfoPanel } from "./info";

const DefaultImageSelectorDisplayComponent = (props) => {

    const defaultImageSelectorWidth = props?.defaultImageSelectorWidth ?? 200;
    const defaultImageSelectorHeight = props?.defaultImageSelectorHeight ?? 120;

    const { t } = useTranslation();
    const {
        onChange,
        onRemove,
        onEdit,
        image
    } = useContext(ImageEditContext);

    return (
        <Fragment>
            <br />
            {image && image?.url && (
                <div className="simplicity-image-editor">
                    <div className="simplicity-image-editor-view">
                        <div className="image-display">
                            <ImageCover
                                image={image}
                                displayWidth={defaultImageSelectorWidth}
                                displayHeight={defaultImageSelectorHeight}
                            />

                            <div className="image-actions">
                                <div className="image-info">
                                    <ImageInfoPanel image={image} />
                                </div>
                                <div className="image-action-edit">
                                    <Button className="image-display-btn" onClick={onEdit}>
                                        {t("commons.edit")}
                                    </Button>
                                </div>
                                <div className="image-action-change">
                                    <Button className="image-display-btn" onClick={onChange}>
                                        {t("commons.change")}
                                    </Button>
                                </div>
                                <div className="image-action-remove">
                                    <Button className="image-display-btn" onClick={onRemove}>
                                        {t("commons.remove")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export { DefaultImageSelectorDisplayComponent };
